module.exports = "<div class=\"mj-card-footer\"></div>\n"